/**
 *
 * A hook that is used to assist with the rendering of breadcrumbs.
 *
 * It returns an array of "crumbs". These crumbs can be looped over and a breadcrumb navigation list can be rendered.
 *
 * @module
 */
import { useContext } from 'react';
import { ArticleContext, CategoryContext } from '../contexts';
/**
 * # useBreadcrumbs
 *
 * The structure of a "crumb" is
 * ```javascript
 * {
 *   linkType: 'category' | 'article';
 *   linkId: string;
 *   title: string;
 * }
 * | {
 *   linkType: 'home';
 *   title: string;
 * };
 * ```
 */
export default function useBreadcrumbs() {
    const article = useContext(ArticleContext);
    const category = useContext(CategoryContext);
    if (article)
        return articleCrumbs(article);
    if (category)
        return categoryCrumbs(category);
    return [];
}
function articleCrumbs(article) {
    const results = [
        {
            linkType: 'category',
            linkId: article.category.id,
            title: article.category.title,
        },
    ];
    if (article.category.parentCategory) {
        results.unshift({
            linkType: 'category',
            linkId: article.category.parentCategory.id,
            title: article.category.parentCategory.title,
        });
    }
    results.unshift({
        linkType: 'home',
        // Localise 'Home'
        title: 'Home',
    });
    return results;
}
function categoryCrumbs(category) {
    const results = [{ linkType: 'home', title: 'Home' }];
    if (category.parentCategory) {
        results.push({
            linkType: 'category',
            linkId: category.parentCategory.id,
            title: category.parentCategory.title,
        });
    }
    return results;
}
//# sourceMappingURL=useBreadcrumbs.js.map